import styled from 'styled-components';

export const StyledForm = styled.form`
    display: flex;
    flex-direction: column;
    row-gap: 0.75rem;
    margin-top: 1rem;
    height: 100%;
`;
